var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"skeleton"},_vm._l((_vm.amount),function(i){return _c('div',{key:i,staticClass:"skeleton__block",style:({ height: _vm.setHeight, width: _vm.setWidth })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }